export enum NbaParamResolverId {
  LocationOriginAndBaseHref = 'locationOriginAndBaseHref',
  Subprocess = 'subprocess',
  Country = 'country',
  Language = 'language',
  VehicleId = 'vehicleId',
  VehicleStageImage = 'vehicleStageImage',
  OnlineCode = 'onlineCode',
  SelectedPerspective = 'selectedPerspective',
  Nst = 'nst',
  Baumuster = 'baumuster',
  SalesTouchSource = 'salesTouchSource',
  SalesTouchEnvironment = 'salesTouchEnvironment',
  MercedesMe = 'mercedesMe',
  TestdriveUrl = 'testdriveUrl'
}
